export const RESPONSIFY_ALGO_RUN_INTERACTION_NAME = 'responsifyAlgoExecution'
export const RESPONSIFY_ALGO_BATCH_INTERACTION_NAME = 'responsifyAlgoBatchExecution'
export const RESPONSIFY_ALGO_FALLBACK_MEASUREMENTS_INTERACTION_NAME = 'responsifyAlgoFallbackMeasurements'

export const RESPONSIFY_ALGO_RUN_ID_PREFIX = 'responsifyAlgo_'
export const RESPONSIFY_ALGO_BATCH_RUN_ID_PREFIX = 'responsifyAlgoBatch_'

export const RESPONSIFY_ALGO_TRANSACTION_NAME = 'responsifyAlgorithm'
export const RESPONSIFY_ALGO_BASELINE_TRANSACTION_NAME = 'responsifyAlgorithmBaseline'
